module.exports = __webpack_public_path__ + "static/media/TIM_logo_2016.5f64768c.svg";